var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEqualizer = function SvgIconEqualizer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 6.375a1 1 0 0 1 1-1h3.375a1 1 0 1 1 0 2H17.25a1 1 0 0 1-1-1M2.375 10.125a1 1 0 0 1 1-1H6.75a1 1 0 0 1 0 2H3.375a1 1 0 0 1-1-1M2.375 13.875a1 1 0 0 1 1-1H6.75a1 1 0 1 1 0 2H3.375a1 1 0 0 1-1-1M3.375 17a1 1 0 1 0 0 2H6.75a1 1 0 1 0 0-2zM9.313 13.875a1 1 0 0 1 1-1h3.374a1 1 0 1 1 0 2h-3.374a1 1 0 0 1-1-1M10.313 17a1 1 0 1 0 0 2h3.374a1 1 0 1 0 0-2zM17.25 9.125a1 1 0 1 0 0 2h3.375a1 1 0 1 0 0-2zM16.25 13.875a1 1 0 0 1 1-1h3.375a1 1 0 1 1 0 2H17.25a1 1 0 0 1-1-1M17.25 16.625a1 1 0 1 0 0 2h3.375a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconEqualizer;